module.exports = __webpack_public_path__ + "static/media/chess-knight-alt.31a57cea.svg";